module.exports = __webpack_public_path__ + "img/business_deal.0a6326db.svg";